import axios from 'axios';
import { useQuery, useMutation } from '@tanstack/react-query';

export const useCoverageMapPoints = (params = {}, opts = {}) =>
  useQuery(
    ['coverage-map-points', params],
    async () => {
      const res = await axios.get('/coverage-map/points', { params });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      ...opts,
    },
  );

// One-shot fetch for a client's name + city (popup detail).
export async function fetchClientDetail(userId) {
  const res = await axios.get(`/coverage-map/client/${userId}`);
  return res.data;
}

// Server-side uncovered calc — Postgres Haversine, scales to 10k+ clients
// without a main-thread freeze. Same staleTime as points so they refresh
// together after a radius mutation.
export const useCoverageMapUncovered = (opts = {}) =>
  useQuery(
    ['coverage-map-uncovered'],
    async () => {
      const res = await axios.get('/coverage-map/uncovered');
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      ...opts,
    },
  );

export const useUpdateProviderRadius = (callback, opts = {}) =>
  useMutation(
    async ({ userId, radiusMiles }) => {
      const res = await axios.patch(
        `/coverage-map/provider/${userId}/radius`,
        { radiusMiles },
      );
      return res.data;
    },
    { ...opts, onSuccess: callback || (() => {}) },
  );
